import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Briefcase, Megaphone, MessageSquare, ClipboardList, Sparkles } from "lucide-react";

const LINKS = [
  { to: "/dashboard/annonces", label: "Annonces de l'école", icon: Megaphone, desc: "Communications internes" },
  { to: "/dashboard/messages", label: "Messagerie", icon: MessageSquare, desc: "Échangez avec vos collègues" },
  { to: "/dashboard/pointage", label: "Mon pointage", icon: ClipboardList, desc: "Présences et horaires" },
  { to: "/dashboard/ai", label: "MAZID AI", icon: Sparkles, desc: "Assistant intelligent" },
];

export default function StaffDashboard() {
  const { user } = useAuth();
  return (
    <div className="space-y-6" data-testid="staff-dashboard">
      <div>
        <div className="chip mb-2"><Briefcase className="h-3 w-3" /><span>Espace Personnel</span></div>
        <h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-[#1E3A8A] tracking-tight">
          Bienvenue, {user?.full_name}
        </h2>
        <p className="text-sm text-slate-500 mt-1">Vos accès dépendent des habilitations de votre poste. Les modules autorisés apparaissent dans le menu de gauche.</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        {LINKS.map(({ to, label, icon: Icon, desc }) => (
          <Link key={to + label} to={to} className="bg-white border border-slate-200 rounded-xl p-5 hover:shadow-md hover:border-[#1E3A8A]/30 transition-shadow flex gap-4 items-start" data-testid={`staff-link-${label}`}>
            <div className="w-10 h-10 rounded-lg bg-[#1E3A8A]/10 text-[#1E3A8A] flex items-center justify-center flex-shrink-0">
              <Icon className="h-5 w-5" />
            </div>
            <div>
              <div className="font-heading font-bold text-[#0F172A]">{label}</div>
              <div className="text-xs text-slate-500 mt-0.5">{desc}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
